module.exports = __webpack_public_path__ + "img/service-sp-screen-character.9dd64ad2.png";